import { Component, Input } from '@angular/core';
import { GenGaListNames } from 'src/app/generac/enums/ga-list-names.enum';
import { TooltipPosition } from 'src/app/generac/enums/tooltip-position.enum';
import { GenInfoPriceWrapperComponent } from 'src/app/generac/shared/components/info-price-wrapper/info-price-wrapper.component';
import { CommonModule } from '@angular/common';
import { I18nModule, Product, UrlModule } from '@spartacus/core';
import { IconModule, MediaModule } from '@spartacus/storefront';
import { GenAddToCartModule } from 'src/app/generac/features/cart/product-add-to-cart/product-add-to-cart.module';
import { GenSharedModule } from 'src/app/generac/shared/shared.module';
import { GenInfoMessageComponent } from 'src/app/generac/shared/components/info-message/info-message.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'gen-product-warranty-item',
  templateUrl: './product-warranty-item.component.html',
  imports: [
    CommonModule,
    I18nModule,
    GenSharedModule,
    IconModule,
    MediaModule,
    UrlModule,
    RouterModule,
    GenInfoMessageComponent,
    GenInfoPriceWrapperComponent,
    GenAddToCartModule,
  ],
})
export class GenProductWarrantyItemComponent {
  @Input() warranty: Product;
  @Input() userUid: string;
  @Input() tooltipMessage: string;
  @Input() set phoneNumberOrEmail(value: string) {
    this.contactForPricingHref = value?.includes('@') ? `mailto: ${value}` : `tel: ${value}`;
    this._phoneNumberOrEmail = value;
  }

  get phoneNumberOrEmail(): string {
    return this._phoneNumberOrEmail;
  }
  _phoneNumberOrEmail: string;

  callForPricingMessage = '';
  contactForPricingHref: string;
  gaListName: GenGaListNames = GenGaListNames.WARRANTIES;
  TooltipPosition = TooltipPosition;
}
